import { useCallback } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const HELP_CENTER_AUTH0_AUDIENCE =
  import.meta.env.VITE_HELP_CENTER_AUTH0_AUDIENCE || 'https://api.vttd.stonesai.com';

export function useHelpCenterAccessToken() {
  const { getAccessTokenSilently } = useAuth0();

  return useCallback(
    () =>
      getAccessTokenSilently({
        authorizationParams: {
          audience: HELP_CENTER_AUTH0_AUDIENCE,
        },
      }),
    [getAccessTokenSilently],
  );
}
